import { PageContainer } from '../../components/Layout/PageContainer';
import { PageBreadcrumb } from '../../components/UI/PageBreadcrumb';

export function CompetitionsPage() {
  return (
    <PageContainer>
      <PageBreadcrumb items={['Home', 'Competitions']} />
      <p>Competitions content goes here</p>
    </PageContainer>
  );
}